module.exports = __webpack_public_path__ + "img/2.e2ba9e4d.png";